<div class="container__text container__text--center text">
  <p class="no-default-bottom-margin">{{ title }}</p>
  <ol>
    <li *ngFor="let s of species$ | async">{{ format(s) }}</li>
  </ol>
</div>
